import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import { useSelector } from "react-redux"
import useToggle from "../../../../hooks/toggle"
import {  getexternaldocuments, getSavedOfferDetails, savetidewater } from "../../../../api/transaction"
import { selecteddocumentesign } from "../ReviewDocs"
import { useParams } from "react-router-dom"
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react"
const ALAtidewater = () => {
    const {id,user} : any = useParams()
    const componentRef = useRef();
    const [loader,setloading] = useState(false)
    const [tidewater, setTidewater] = useState({
        offer_id: id,
        lapp_case: "",
        property_address: "",
        name_of_veteran: "",
        address: [
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ],
        proximity:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        sales_price:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        price_gross_area:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        data_source:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        salesorfinancing:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ],
        dateofsale:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        location:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ],
        site_view:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        design_appeal:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        quality_construction:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        age:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        condition:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        above_grade:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        gross_living_area:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        basement:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        room_below_grade:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        functional_utility:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        heating_cooling:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        garage_carport:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        pool_porches:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        energy_efficient:[{
            subject: "",
            comp1: "",
            comp2: "",
            comp3: ""
        }] ,
        fireplace:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        other:[
            {
                subject: "",
                comp1: "",
                comp2: "",
                comp3: ""
            }
        ] ,
        remarks: ""

    })
//@ts-ignore
    const val = useSelector((state)=>state?.new?.signset)
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [offerdetails, setOfferDetails] = useState({});
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid : "",
      document_name: "",
      image_base64: "",
      sign_role: 1
      })

           
      const printf = () => {
            // window.print()
            handlePrint()
      };
      

     const send = async()=>{
        setloading(true)
       const res = await savetidewater(tidewater)
       if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
       setloading(false)
}   

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

useEffect(()=>{
    (async function(){
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
      const res =await getexternaldocuments(id,"tidewater") 
      setTidewater({...tidewater,
        lapp_case: res?.data?.lapp_case,
    
        name_of_veteran: res?.data?.name_of_veteran,
        address: [
            {
                subject: res?.data?.address[0].subject,
                comp1: res?.data?.address[0].comp1,
                comp2: res?.data?.address[0].comp2,
                comp3: res?.data?.address[0].comp3
            }
        ],
        proximity:[
            {
                subject: res?.data?.proximity[0].subject,
                comp1: res?.data?.proximity[0].comp1,
                comp2: res?.data?.proximity[0].comp2,
                comp3: res?.data?.proximity[0].comp3
            }
        ] ,
        sales_price:[
            {
                subject: res?.data?.sales_price[0].subject,
                comp1: res?.data?.sales_price[0].comp1,
                comp2: res?.data?.sales_price[0].comp2,
                comp3: res?.data?.sales_price[0].comp3
            }
        ] ,
        price_gross_area:[
            {
                subject: res?.data?.price_gross_area[0].subject,
                comp1: res?.data?.price_gross_area[0].comp1,
                comp2: res?.data?.price_gross_area[0].comp2,
                comp3: res?.data?.price_gross_area[0].comp3
            }
        ] ,
        data_source:[
            {
                subject: res?.data?.data_source[0].subject,
                comp1: res?.data?.data_source[0].comp1,
                comp2: res?.data?.data_source[0].comp2,
                comp3: res?.data?.data_source[0].comp3
            }
        ] ,
        salesorfinancing:[
            {
                subject: res?.data?.salesorfinancing[0].subject,
                comp1: res?.data?.salesorfinancing[0].comp1,
                comp2: res?.data?.salesorfinancing[0].comp2,
                comp3: res?.data?.salesorfinancing[0].comp3
            }
        ],
        dateofsale:[
            {
                subject:  res?.data?.dateofsale[0].subject,
                comp1:  res?.data?.dateofsale[0].comp1,
                comp2:  res?.data?.dateofsale[0].comp2,
                comp3:  res?.data?.dateofsale[0].comp3
            }
        ] ,
        location:[
            {
                subject:  res?.data?.location[0].subject,
                comp1:  res?.data?.location[0].comp1,
                comp2:  res?.data?.location[0].comp2,
                comp3:  res?.data?.location[0].comp3
            }
        ],
        site_view:[
            {
                subject:  res?.data?.site_view[0].subject,
                comp1:  res?.data?.site_view[0].comp1,
                comp2:  res?.data?.site_view[0].comp2,
                comp3:  res?.data?.site_view[0].comp3
            }
        ] ,
        design_appeal:[
            {
                subject:  res?.data?.design_appeal[0].subject,
                comp1:  res?.data?.design_appeal[0].comp1,
                comp2:  res?.data?.design_appeal[0].comp2,
                comp3:  res?.data?.design_appeal[0].comp3
            }
        ] ,
        quality_construction:[
            {
                subject:  res?.data?.quality_construction[0].subject,
                comp1:  res?.data?.quality_construction[0].comp1,
                comp2:  res?.data?.quality_construction[0].comp2,
                comp3:  res?.data?.quality_construction[0].comp3
            }
        ] ,
        age:[{
            subject:  res?.data?.age[0].subject,
            comp1:  res?.data?.age[0].comp1,
            comp2:  res?.data?.age[0].comp2,
            comp3:  res?.data?.age[0].comp3
        }] ,
        condition:[{
            subject:  res?.data?.condition[0].subject,
            comp1:  res?.data?.condition[0].comp1,
            comp2:  res?.data?.condition[0].comp2,
            comp3:  res?.data?.condition[0].comp3
        }] ,
        above_grade:[{
            subject:  res?.data?.above_grade[0].subject,
            comp1:  res?.data?.above_grade[0].comp1,
            comp2:  res?.data?.above_grade[0].comp2,
            comp3:  res?.data?.above_grade[0].comp3
        }] ,
        gross_living_area:[{
            subject:  res?.data?.gross_living_area[0].subject,
            comp1:  res?.data?.gross_living_area[0].comp1,
            comp2:  res?.data?.gross_living_area[0].comp2,
            comp3:  res?.data?.gross_living_area[0].comp3
        }] ,
        basement:[{
            subject:  res?.data?.basement[0].subject,
            comp1:  res?.data?.basement[0].comp1,
            comp2:  res?.data?.basement[0].comp2,
            comp3:  res?.data?.basement[0].comp3
        }] ,
        room_below_grade:[{
            subject:  res?.data?.room_below_grade[0].subject,
            comp1:  res?.data?.room_below_grade[0].comp1,
            comp2:  res?.data?.room_below_grade[0].comp2,
            comp3:  res?.data?.room_below_grade[0].comp3
        }] ,
        functional_utility:[{
            subject:  res?.data?.functional_utility[0].subject,
            comp1:  res?.data?.functional_utility[0].comp1,
            comp2:  res?.data?.functional_utility[0].comp2,
            comp3:  res?.data?.functional_utility[0].comp3
        }] ,
        heating_cooling:[{
            subject:  res?.data?.heating_cooling[0].subject,
            comp1:  res?.data?.heating_cooling[0].comp1,
            comp2:  res?.data?.heating_cooling[0].comp2,
            comp3:  res?.data?.heating_cooling[0].comp3
        }] ,
        garage_carport:[{
            subject:  res?.data?.garage_carport[0].subject,
            comp1:  res?.data?.garage_carport[0].comp1,
            comp2:  res?.data?.garage_carport[0].comp2,
            comp3:  res?.data?.garage_carport[0].comp3
        }] ,
        pool_porches:[{
            subject:  res?.data?.pool_porches[0].subject,
            comp1:  res?.data?.pool_porches[0].comp1,
            comp2:  res?.data?.pool_porches[0].comp2,
            comp3:  res?.data?.pool_porches[0].comp3
        }] ,
        energy_efficient:[{
            subject:  res?.data?.energy_efficient[0].subject,
            comp1:  res?.data?.energy_efficient[0].comp1,
            comp2:  res?.data?.energy_efficient[0].comp2,
            comp3:  res?.data?.energy_efficient[0].comp3
        }] ,
        fireplace:[
            {
                subject:  res?.data?.fireplace[0].subject,
                comp1:  res?.data?.fireplace[0].comp1,
                comp2:  res?.data?.fireplace[0].comp2,
                comp3:  res?.data?.fireplace[0].comp3
            }
        ] ,
        other:[
            {
                subject:  res?.data?.other[0].subject,
                comp1:  res?.data?.other[0].comp1,
                comp2:  res?.data?.other[0].comp2,
                comp3:  res?.data?.other[0].comp3
            }
        ] ,
        remarks: res?.data?.remarks

      })
    })()
  },[])

    return (
        <>
            <table
                style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }} ref={componentRef}
                >
                <tbody>
                    <tr>
                        <td>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr >
                                        <td style={{ width: "90%" }}>
                                            <img
                                                style={{ width: 250 }}
                                                src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                                            />
                                        </td>
                                        <td>
                                            <img
                                                style={{ width: 30 }}
                                                src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                                                alt=""
                                            />
                                            <img
                                                style={{ width: 50 }}
                                                src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                                                alt=""
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: "center" }}>
                            <span style={{ fontSize: 30, fontWeight: 600 }}>Tidewater</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: 10 }}>
                            <span>
                                LAPP Case #:
                                <input
                                    type="text"
                                    value={tidewater?.lapp_case}
                                    onChange={(e) => setTidewater({ ...tidewater, lapp_case: e.target.value })}
                                    style={{
                                        outline: "none",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        width: "85%"
                                    }}
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: 10 }}>
                            <span>
                                Subject Property Address:
                                <input
                                    type="text"//@ts-ignore
                                    value={offerdetails?.propertyAddress}
                                    // onChange={(e) => setTidewater({ ...tidewater, property_address: e.target.value })}
                                    style={{
                                        outline: "none",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        width: "80%"
                                    }}
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: 10 }}>
                            <span>
                                Name of Veteran:
                                <input
                                    type="text"
                                    value={tidewater?.name_of_veteran}
                                    onChange={(e) => setTidewater({ ...tidewater, name_of_veteran: e.target.value })}
                                    style={{
                                        outline: "none",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        width: "80%"
                                    }}
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "10px 0px" }}>
                            <table style={{ width: "100%", tableLayout: "fixed" }}  id="tideWaterBorder">
                                <tbody>
                                    <tr>
                                        <th style={{ backgroundColor: "black", color: "#cc652c" }}>
                                            ITEM
                                        </th>
                                        <th style={{ backgroundColor: "black", color: "#cc652c" }}>
                                            SUBJECT
                                        </th>
                                        <th style={{ backgroundColor: "black", color: "#cc652c" }}>
                                            COMP #1
                                        </th>
                                        <th style={{ backgroundColor: "black", color: "#cc652c" }}>
                                            COMP #2
                                        </th>
                                        <th style={{ backgroundColor: "black", color: "#cc652c" }}>
                                            COMP #3
                                        </th>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr>
                                        <td>Address</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.address[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, address: [{...tidewater.address[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea

                                                value={tidewater?.address[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, address: [{...tidewater.address[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.address[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, address: [{...tidewater.address[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.address[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, address: [{...tidewater.address[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Proximity to Subject</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.proximity[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, proximity: [{...tidewater.proximity[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.proximity[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, proximity: [{...tidewater.proximity[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.proximity[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, proximity: [{...tidewater.proximity[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.proximity[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, proximity: [{...tidewater.proximity[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Price/Gross Liv. Area</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.price_gross_area[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, price_gross_area: [{...tidewater.price_gross_area[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.price_gross_area[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, price_gross_area: [{...tidewater.price_gross_area[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.price_gross_area[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, price_gross_area: [{...tidewater.price_gross_area[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.price_gross_area[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, price_gross_area: [{...tidewater.price_gross_area[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Data Source</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.data_source[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, data_source: [{...tidewater.data_source[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.data_source[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, data_source: [{...tidewater.data_source[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.data_source[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, data_source: [{...tidewater.data_source[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.data_source[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, data_source: [{...tidewater.data_source[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sales or Financing Concessions</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.salesorfinancing[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, salesorfinancing: [{...tidewater.salesorfinancing[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.salesorfinancing[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, salesorfinancing: [{...tidewater.salesorfinancing[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.salesorfinancing[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, salesorfinancing: [{...tidewater.salesorfinancing[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.salesorfinancing[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, salesorfinancing: [{...tidewater.salesorfinancing[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Date of Sale/Time</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.dateofsale[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, dateofsale: [{...tidewater.dateofsale[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.dateofsale[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, dateofsale: [{...tidewater.dateofsale[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.dateofsale[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, dateofsale: [{...tidewater.dateofsale[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.dateofsale[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, dateofsale: [{...tidewater.dateofsale[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Location</td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.location[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, location: [{...tidewater.location[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.location[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, location: [{...tidewater.location[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />{" "}
                                        </td>
                                        <td>
                                            {" "}
                                            <textarea
                                                value={tidewater?.location[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, location: [{...tidewater.location[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.location[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, location: [{...tidewater.location[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>{" "}
                                    <tr>
                                        <td>Site/View</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.site_view[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, site_view: [{...tidewater.site_view[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.site_view[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, site_view: [{...tidewater.site_view[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.site_view[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, site_view: [{...tidewater.site_view[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.site_view[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, site_view: [{...tidewater.site_view[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Design/Appeal</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.design_appeal[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, design_appeal: [{...tidewater.design_appeal[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.design_appeal[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, design_appeal: [{...tidewater.design_appeal[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.design_appeal[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, design_appeal: [{...tidewater.design_appeal[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.design_appeal[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, design_appeal: [{...tidewater.design_appeal[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Quality of Construction</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.quality_construction[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, quality_construction: [{...tidewater.quality_construction[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.quality_construction[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, quality_construction: [{...tidewater.quality_construction[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.quality_construction[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, quality_construction: [{...tidewater.quality_construction[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.quality_construction[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, quality_construction: [{...tidewater.quality_construction[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Age</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.age[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, age: [{...tidewater.age[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.age[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, age: [{...tidewater.age[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.age[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, age: [{...tidewater.age[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.age[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, age: [{...tidewater.age[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Condition</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.condition[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, condition: [{...tidewater.condition[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.condition[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, condition: [{...tidewater.condition[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.condition[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, condition: [{...tidewater.condition[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.condition[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, condition: [{...tidewater.condition[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Above Grade Room Count</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.above_grade[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, above_grade: [{...tidewater.above_grade[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.above_grade[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, above_grade: [{...tidewater.above_grade[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.above_grade[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, above_grade: [{...tidewater.above_grade[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.above_grade[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, above_grade: [{...tidewater.above_grade[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Gross Living Area</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.gross_living_area[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, gross_living_area: [{...tidewater.gross_living_area[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.gross_living_area[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, gross_living_area: [{...tidewater.gross_living_area[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.gross_living_area[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, gross_living_area: [{...tidewater.gross_living_area[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.gross_living_area[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, gross_living_area: [{...tidewater.gross_living_area[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Basement</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.basement[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, basement: [{...tidewater.basement[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.basement[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, basement: [{...tidewater.basement[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.basement[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, basement: [{...tidewater.basement[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.basement[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, basement: [{...tidewater.basement[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Rooms Below Grade</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.room_below_grade[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, room_below_grade: [{...tidewater.room_below_grade[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.room_below_grade[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, room_below_grade: [{...tidewater.room_below_grade[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.room_below_grade[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, room_below_grade: [{...tidewater.room_below_grade[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.room_below_grade[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, room_below_grade: [{...tidewater.room_below_grade[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Functional Utility</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.functional_utility[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, functional_utility: [{...tidewater.functional_utility[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.functional_utility[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, functional_utility: [{...tidewater.functional_utility[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.functional_utility[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, functional_utility: [{...tidewater.functional_utility[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.functional_utility[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, functional_utility: [{...tidewater.functional_utility[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Heating/Cooling</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.heating_cooling[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, heating_cooling: [{...tidewater.heating_cooling[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.heating_cooling[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, heating_cooling: [{...tidewater.heating_cooling[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.heating_cooling[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, heating_cooling: [{...tidewater.heating_cooling[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.heating_cooling[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, heating_cooling: [{...tidewater.heating_cooling[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Garage/Carport</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.garage_carport[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, garage_carport: [{...tidewater.garage_carport[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.garage_carport[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, garage_carport: [{...tidewater.garage_carport[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.garage_carport[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, garage_carport: [{...tidewater.garage_carport[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.garage_carport[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, garage_carport: [{...tidewater.garage_carport[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Pool, Porches. Patio</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.pool_porches[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, pool_porches: [{...tidewater.pool_porches[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.pool_porches[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, pool_porches: [{...tidewater.pool_porches[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.pool_porches[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, pool_porches: [{...tidewater.pool_porches[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.pool_porches[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, pool_porches: [{...tidewater.pool_porches[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Energy Efficient Items</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.energy_efficient[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, energy_efficient: [{...tidewater.energy_efficient[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.energy_efficient[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, energy_efficient: [{...tidewater.energy_efficient[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.energy_efficient[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, energy_efficient: [{...tidewater.energy_efficient[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.energy_efficient[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, energy_efficient: [{...tidewater.energy_efficient[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Fireplaces</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.fireplace[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, fireplace: [{...tidewater.fireplace[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.fireplace[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, fireplace: [{...tidewater.fireplace[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.fireplace[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, fireplace: [{...tidewater.fireplace[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.fireplace[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, fireplace: [{...tidewater.fireplace[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Other</td>
                                        <td>
                                            <textarea
                                                value={tidewater?.other[0]?.subject}
                                                onChange={(e) => setTidewater({ ...tidewater, other: [{...tidewater.other[0],subject: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.other[0]?.comp1}
                                                onChange={(e) => setTidewater({ ...tidewater, other: [{...tidewater.other[0],comp1: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.other[0]?.comp2}
                                                onChange={(e) => setTidewater({ ...tidewater, other: [{...tidewater.other[0],comp2: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                value={tidewater?.other[0]?.comp3}
                                                onChange={(e) => setTidewater({ ...tidewater, other: [{...tidewater.other[0],comp3: e.target.value}]})}
                                                style={{
                                                    border: "none",
                                                    resize: "none",
                                                    width: "100%",
                                                    outline: "none"
                                                }}
                                                defaultValue={""}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "10px 0px" }}>
                            <span>
                                Remarks:{" "}
                                <textarea
                                value={tidewater?.remarks}
                               onChange={(e) => setTidewater({ ...tidewater, remarks: e.target.value  })}
                                    style={{ width: "100%", height: 200, resize: "none" }}
                                    defaultValue={""}
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "10px 0px" }}>
                            <span>
                                Other provisions: Earnest deposit to be delivered within (5) business
                                days
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>


<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    {/* <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>  */}
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>

        </>
    )
}
export default ALAtidewater